// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"1c6fb51d","866":"a393f689"}[chunkId] + ".chunk.css";
};